import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { IReduxAppState } from "../reducers";
import Outstanding from './Outstanding';
import SquarePrompt from './SquarePrompt';

const PromptManager = () => {
    const { search } = useLocation();
    const subscription = useSelector((state: IReduxAppState) => state.subscription);
    const selectedVenueId = useSelector((state: IReduxAppState) => state.selectedVenueId);
    const isSquareAuthRevoked = useSelector((state: IReduxAppState) => state.venue[selectedVenueId]?.venueSettings?.integration_account_link_revoked);
    const code = new URLSearchParams(search).get("code");
    if(subscription === 'SQUARE' && isSquareAuthRevoked && !code){
        return <SquarePrompt />
    }
    return (
        <Outstanding />
    )
}

export default PromptManager;